import { BehaviorSubject, Subject } from 'rxjs';
import { compare, compareDate, filter } from 'projects/common/src/app/services/utils/utilities';
import { IPagination } from '../components/mt-table-pagination/mt-table-pagination.component';

export class MtTable {
  private originalSource; // original data without sorting or paging
  private enabledPaging: boolean;
  private dateFields: string[];

  // sort
  public source$: BehaviorSubject<any[]>;
  public collectionSize$: Subject<number>;
  public sort$ = new BehaviorSubject({ column: '', direction: '' });

  public column = '';
  public direction = '';

  // paging
  public pageSize = 10;
  public page: number;
  public amountPages;
  public inputPage;

  // filter
  private term: string;
  /**
   *
   * @param data data to display in the table
   * @param enabledPaging enable pagination
   * @param pageSize number of records to display in the table
   */
  constructor(enabledPaging: boolean, pageSize?: number, dateFields?: string[]) {
    this.enabledPaging = enabledPaging;
    this.dateFields = dateFields || [];
    this.pageSize = pageSize;
    this.page = 1;

    this.source$ = new BehaviorSubject([]);
    this.collectionSize$ = new BehaviorSubject(0);
  }

  /**
   * paginate data for table
   *
   * @param data data to paginate
   */
  private paginate(data: any): void {
    data = data || [];
    data = data.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.source$.next(data);
  }

  /**
   * Method to fill the table
   *
   * @param data array of data with wich the table wiil be filled
   */
  public init(data: any[]): void {
    this.originalSource = data;
    this.sort(this.column, this.direction);
  }

  /**
   * Sort data
   *
   * @param column column to sort data
   * @param direction direction to sort data
   */
  public sort(column: string, direction: string): void {
    this.column = column;
    this.direction = direction;
    let arr;

    // si term contiene un valor significa que se esta filtrando (search)
    if (this.term) {
      arr = filter([...this.originalSource], this.term, ['']);
    } else {
      arr = this.originalSource ? [...this.originalSource] : [];
    }

    if (direction !== '') {
      // Manejará campos que son fechas
      if (this.dateFields.length) {
        const dateField = this.dateFields.find((value) => value === column); // comprueba que la columana a ordenar se encuentre en los campos fechas(dateFields)

        if (dateField) {
          arr = arr.sort((a, b) => {
            const v1 = a[column] ? a[column] : '0001-01-01T00:00:00+00:00'; // por si las columnas vienen vacias
            const v2 = b[column] ? b[column] : '0001-01-01T00:00:00+00:00';
            const res = compareDate(v1, v2);
            return direction === 'asc' ? res : -res;
          });
        } else {
          arr = arr.sort((a, b) => {
            const v1 = a[column] ? a[column] : ''; // por si las columnas vienen vacias
            const v2 = b[column] ? b[column] : '';
            const res = compare(v1, v2);
            return direction === 'asc' ? res : -res;
          });
        }
      } else {
        arr = arr.sort((a, b) => {
          const v1 = a[column] ? a[column] : '';
          const v2 = b[column] ? b[column] : '';
          const res = compare(v1, v2);
          return direction === 'asc' ? res : -res;
        });
      }
    }

    if (this.enabledPaging) {
      this.paginate(arr);
    } else {
      this.source$.next(arr);
    }

    this.sort$.next({ column, direction }); // trigger when column header is clicked
    this.collectionSize$.next(arr.length);
  }

  /**
   * change the number of recors to display
   */
  public changePageSize(value: IPagination): void {
    this.pageSize = value.pageSize;
    this.page = value.page;
    this.sort(this.column, this.direction);
  }

  /**
   *  Change the page
   *
   * @param value number of page
   */
  public changePage(value: number): void {
    this.page = value;
    this.sort(this.column, this.direction);
  }

  /**
   * Filter data by text
   *
   * @param term string to filter data
   */
  public search(term: string): void {
    this.page = 1; // reset page
    this.term = term;
    this.sort(this.column, this.direction);
  }

  /**
   * return the original source without sorting or paging
   */
  public getOriginalSource(): any[] {
    return this.originalSource;
  }
}
